<template>
	<AssessmentCharacteristics class="better-leader-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `person-circle-exclamation` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.BetterLeaderCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "BetterLeaderCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.leader?.becomeBetterLeader || "";
		},
	},
};
</script>

<style lang="scss" scoped></style>
